import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardScreen from "../Views/DashboardModule/DashboardScreen";
import MerchantRequestsScreen from "../Views/MerchantModule/MerchantRequestsScreen";
import ProjectScreen from "../Views/ProjectModule/ProjectScreen";
import CommissionScreen from "../Views/SettingsModule/CommissionPage";
import WithdrawalScreen from "../Views/WithdrawalModule/WIthdrawalPage";
import SupportScreen from "../Views/SupportModule/SupportPage";
import AllMerchantScreen from "../Views/MerchantModule/AllMerchantScreen";
import MerchantProfileScreen from "../Views/MerchantModule/MerchantProfileScreen";
import ChatIndexScreen from "../Views/ChatModule/chatIndexScreen";
import ChatAdmin from "../Views/ChatModule/chatAdminComponent";
import ChatKeywordSearch from "../Views/ChatModule/chatKeywordSearchComponent";
import VerifyProjectScreen from "../Views/ProjectModule/VerifyProjectScreen";
import AllProjectScreen from "../Views/ProjectModule/AllProjectsScreen";
import ProjectDetailsScreen from "../Views/ProjectModule/ProjectDetailsScreen";
import CouponScreen from "../Views/CouponModule/CouponScreen";
import AllCustomerScreen from "../Views/CustomerModule/AllCustomerScreen";
import CustomerProfileScreen from "../Views/CustomerModule/CustomerProfileScreen";

export default function MainNavigator() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Layout />}> */}
        {/* <Route index element={<Home />} /> */}
        {/* <Route path="/" element={<DashboardScreen />} /> */}
        {/* <Route path="/Merchant" element={<MerchantScreen />} /> */}
        <Route path="/" element={<MerchantRequestsScreen />} />
        <Route path="/allMerchants" element={<AllMerchantScreen />} />
        <Route
          path="/allMerchants/:merchantId"
          element={<MerchantProfileScreen />}
        />
        <Route path="/allCustomers" element={<AllCustomerScreen />} />
        <Route
          path="/allCustomers/:customerId"
          element={<CustomerProfileScreen />}
        />

        <Route path="/chat" element={<ChatIndexScreen />}>
          <Route index element={<ChatAdmin />} />
          <Route path="keywordSearch" element={<ChatKeywordSearch />} />
          {/* <Route path="createOrder" element={<CreateOrderScreen />} />
          <Route path="accept" element={<AcceptOrderScreen />} /> */}
        </Route>
        <Route path="/VerifyProject" element={<VerifyProjectScreen />} />
        <Route path="/allprojects" element={<AllProjectScreen />} />
        <Route
          path="/project-details/:id/:status"
          element={<ProjectDetailsScreen />}
        />
        <Route path="/project" element={<ProjectScreen />} />
        <Route path="/commission" element={<CommissionScreen />} />
        <Route path="/withdrawal" element={<WithdrawalScreen />} />
        <Route path="/support" element={<SupportScreen />} />
        <Route path="/coupon" element={<CouponScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
